/**
 * PMS Integration Service
 *
 * Provider-agnostic PMS integration exports
 */

export type {
  DocumentSyncAuditAlreadyRunning,
  DocumentSyncAuditCounts,
  DocumentSyncAuditDispatched,
  DocumentSyncAuditItem,
  DocumentSyncAuditItemKind,
  DocumentSyncAuditItemState,
  DocumentSyncAuditResponse,
  DocumentSyncAuditSkippedItem,
  DocumentSyncAuditSyncResult,
  DocumentSyncAuditTraceParticipant,
  ImportSingleMatterRequest,
  ImportSingleMatterResponse,
  ImportSingleMatterStatus,
  MatterLookupResult,
  PmsContactTypeCatalogue,
  PmsContactTypeOption,
  PmsContactTypesResponse,
  PmsMatterContact,
  PmsProvider,
  PmsStatus
} from './types';
// `provider-presentation` is deliberately NOT re-exported here: suites that `jest.mock` this barrel
// with a partial factory would resolve the registry to `undefined` at module-init time. Import
// `@/lib/services/integrations/pms/provider-presentation` directly — see that module's header.
export { getPmsStatus } from './actions';
export {
  INTEGRATION_REAUTH_REQUIRED_CODE,
  isIntegrationReauthRequiredError
} from './integration-auth-error';
export { downloadSkippedExportsReport } from './report-actions';
export {
  getPmsContactTypes,
  refreshPmsContactTypes
} from './contact-types-client';
export { publishesContactTypeCatalogue } from './contact-type-catalogue-state';
export {
  getDocumentSyncAudit,
  triggerDocumentSyncAudit
} from './document-sync-audit-client';
export {
  usePmsStatus,
  usePmsContactTypes,
  usePmsContactTypeSelection,
  useRefreshPmsContactTypes,
  usePmsMatterContacts,
  useDocumentSyncAudit,
  useTriggerDocumentSyncAudit,
  documentSyncAuditQueryKey,
  DOCUMENT_SYNC_AUDIT_POLL_INTERVAL_MS,
  pmsContactTypesQueryKey,
  pmsMatterContactsQueryKey,
  PMS_STATUS_QUERY_KEY
} from './hooks';
export {
  IMPORT_SINGLE_POLL_INTERVAL_MS,
  getPmsImportSingleStatus,
  getPmsMatterContacts,
  importSinglePmsMatter,
  lookupPmsMatterByReference,
  lookupPmsMattersByClientName
} from './import-client';
